import React from "react";
import { createTheme, ThemeProvider } from "@material-ui/core";

import AppRoutes from "./Routes/index";

const theme = createTheme({
  palette: {
    primary: {
      main: "#410660",
    },
  },
});

const App = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <AppRoutes />
    </ThemeProvider>
  );
};

export default App;
